import moment from "moment";
import AllowanceClient from "@/api/CampusAdmin/AllowanceClient"
import { isEmail } from "@/helpers"

export default class Workflow {
  static STEP_ONE = 0;
  static AS_OF = 1;
  static HANDLE_MISSING = 2;
  static INDIVIDUAL_CREDITS = 3;
  static WORKSHOP_CREDITS = 4;
  static UPLOAD_FILE = 5;
  static WHAT_IF = 6;
  static SAVING = 7;
  static COMPLETE = 8;

  constructor(schoolId, http) {
    this.step = Workflow.STEP_ONE;
    this.client = new AllowanceClient(http);

    this.schoolId = schoolId;
    this.identifiers = [];
    this.errors = [];
    this.individualCredits = null;
    this.workshopCredits = null;
    this.zeroOutMissing = null;
    this.whatIf = null;
    this.asOf = moment().startOf('day');
  } 

  async getWhatIf() {
    try {
      const allowances = this.identifiers.map(x => ({
        email: x.email,
        ssoId: x.ssoId,
        individualCredits: this.individualCredits,
        workshopCredits: this.workshopCredits,
        asOf: this.asOf
      }));

      const response = await this.client.whatIfBulkSetCheck(
        this.schoolId, 
        this.zeroOutMissing, 
        allowances);

      this.whatIf = response;
      
    } catch(ex) {
      this.errors.push(ex.toString())
      console.error(ex);
    }
  }
  async uploadAllowances() {
    try {
      const allowances = this.identifiers.map(x => ({
        email: x.email,
        ssoId: x.ssoId,
        individualCredits: this.individualCredits,
        workshopCredits: this.workshopCredits,
        asOf: this.asOf
      }));

      const response = await this.client.bulkSet(
        this.schoolId, 
        this.zeroOutMissing, 
        allowances);
      
    } catch(ex) {
      this.errors.push(ex.toString())
      console.error(ex);
    }
  }

  midSemesterCorrection() {
    this.step = Workflow.AS_OF;
  }
  newSemester() {
    this.zeroOutMissing = true;
    this.step = Workflow.INDIVIDUAL_CREDITS;
  }
  parseFile(file) {
    this.identifiers.length = 0;
    this.errors.length = 0;
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        var text = event.target.result;
        const rows = text.split(/[\r\n]+/).filter(x => !!x);
        for(const row of rows) {
          const identifer = {
            email: row.toLowerCase()
          };
          
          const cols = row.split(',');
          if(cols.length === 2) {
            identifer.email = cols[0].toLowerCase()
            identifer.ssoId = cols[1]
          } 
  
          if(!isEmail(identifer.email))
            this.errors.push(identifer)
          else
            this.identifiers.push(identifer)
        }

        resolve({ 
          identifiers: this.identifiers, 
          errors: this.errors 
        });
      }
      reader.onerror = reject;

      reader.readAsText(file)
    })
  }
  next() {
    this.step++;
  }
}